export const SET_SETTINGS_DATA = 'SET_SETTINGS_DATA';
export const SET_SINGLE_SETTINGS_DATA = 'SET_SINGLE_SETTINGS_DATA';
export const ADD_SETTINGS_DATA = 'ADD_SETTINGS_DATA';
export const DELETE_SETTINGS_DATA = 'DELETE_SETTINGS_DATA';



// WEBPACK FOOTER //
// ./src/store/modules/settings/action-types.js